import { render } from "./conversation.vue?vue&type=template&id=806a89ee&scoped=true"
import script from "./conversation.vue?vue&type=script&lang=js"
export * from "./conversation.vue?vue&type=script&lang=js"

import "./conversation.vue?vue&type=style&index=0&id=806a89ee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806a89ee"]])

export default __exports__